import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { ISectorFilter } from "../models/filters/sectorFilter";
import { ISectorForm } from "../models/forms/sectorForm";
import { ISectorPDTO } from "../models/dtos/sectorPDTO";

// Service for Sector operations
export default class SectorService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Sector";

    protected static override  getUrlFilter<F extends ISectorFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.buildingId != undefined)
                url += `&BuildingId=${filter.buildingId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:ISectorForm):ISectorPDTO {
        const dto = super.toDTO(obj) as ISectorPDTO;
        return dto;
    }
}